<div id="chart">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [stroke]="chartOptions.stroke"
      [tooltip]="chartOptions.tooltip"
      [dataLabels]="chartOptions.dataLabels"
      [title]="chartOptions.title"
      [legend]="chartOptions.legend"
      [markers]="chartOptions.markers"
      [fill]="chartOptions.fill"
    ></apx-chart>
</div>